import { GuestType } from 'common/enums/guest-type.enum';

export const guestTypeOptions = [
  {
    label: 'Guest',
    value: 'Guest',
  },
  {
    label: 'Service',
    value: 'Service',
  },
  {
    label: 'Delivery',
    value: 'Delivery',
  },
  {
    label: 'Ride share',
    value: 'RideShare',
  },
  {
    label: 'Family',
    value: 'Family',
  },
  {
    label: 'Employee',
    value: 'Employee',
  },
  {
    label: 'Health & Medical',
    value: 'Medical',
  },
];

export const guestTypeMap: Record<GuestType, string> = {
  [GuestType.Guest]: 'Guest',
  [GuestType.Service]: 'Service',
  [GuestType.UrgentService]: 'UrgentService',
  [GuestType.Delivery]: 'Delivery',
  [GuestType.RideShare]: 'Ride share',
  [GuestType.Family]: 'Family',
  [GuestType.Undefined]: 'Undefined',
  [GuestType.Employee]: 'Employee',
  [GuestType.Medical]: 'Health & Medical',
};
